export default __webpack_public_path__ + "d2c036aaddaa44e1f1e48098685bd6e7.jpg";